let apiURL: string = location.origin.includes("localhost")
  ? "https://tvetfinance.dhanushinfotech.com"
  : location.origin;

const apiSmhrURL =
  origin.includes("localhost") ||
  origin.includes("https://tvetfinance.dhanushinfotech.com") ||
  origin.includes("oukinternal.samvaadpro.com")
    ? "https://smhrqainternal.dhanushinfotech.com"
    : origin.includes("oukmydev.konza.go.ke")
      ? "https://smhr.konza.go.ke"
      : "https://smhr.ouk.ac.ke";

export const environment = {
  production: false,
  serviceUrl: `${apiURL}/api/`,
  smhrServiceUrl: `${apiSmhrURL}/api/`,
  fileUrl: `${apiURL}/`,
  videoUrl: `${apiURL}`,
  keycloackUrl: "http://localhost:4200",
  downloadUrl: `${apiURL}/api`,
  SOCKET_ENDPOINT: "http://localhost:3000",
  SamvaadUrl: "https://www.samvaadpro.com/conference/",
  RazorPay_Key: "rzp_live_FuIlkhr9QlHKMl", //Live,
  WebSocket_URL: "https://dev.samvaadpro.com/",
  OpenVidu_URL: "https://openvidu.dhanushinfotech.com:4443",
  reportUrl: `${apiURL}/oukreports/v1/generate`,
  downloadReportUrl: `${apiURL}/oukreports/v1/download/`,
  kuppsUrl:
    apiURL == "https://oukdevapplicant.samvaadpro.com"
      ? "tvetfinance.dhanushinfotech.com" //dev
      : apiURL == "https://oukqaapplicant.samvaadpro.com"
        ? "https://oukinternal.samvaadpro.com" //QA
        : apiURL == "https://oukadmissionsdev.konza.go.ke"
          ? "https://oukmydev.konza.go.ke" //Preprod
          : apiURL == "https://admissions.ouk.ac.ke"
            ? "https://my.ouk.ac.ke"
            : "", //Production
};
